<div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-bg-background">
  <div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-flex tw-flex-col tw-justify-center tw-items-center">
    <div class="max-md:tw-flex-1 tw-min-w-full tw-max-w-full md:tw-min-w-[600px] md:tw-max-w-[600px] tw-h-fit tw-bg-secondary md:tw-rounded-[10px] tw-p-4">
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-3xl tw-text-white tw-text-center tw-mb-10">{{ "change-password" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-28">
        <form [formGroup]="form">
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "password" | translate }}</p>
          <div class="tw-w-full tw-h-fit tw-relative tw-flex tw-items-center tw-bg-white tw-mb-6 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden">
            <input
              class="tw-w-full tw-h-full tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-outline-none tw-pr-8"
              [type]="inputType1"
              formControlName="new_password"
              placeholder="{{ 'enter-your-password' | translate }}"
            />
            <img (click)="showHideField(1)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide1" />
          </div>
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "confirm-password" | translate }}</p>
          <div class="tw-w-full tw-h-fit tw-relative tw-flex tw-items-center tw-bg-white tw-mb-6 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden">
            <input
              class="tw-w-full tw-h-full tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-outline-none tw-pr-8"
              [type]="inputType2"
              formControlName="confirm_new_password"
              placeholder="{{ 'confirm-your-password' | translate }}"
            />
            <img (click)="showHideField(2)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide2" />
          </div>
        </form>
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white tw-mb-6">
          {{ isErrorText | translate }}
        </p>

        <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-6 tw-mb-6">
          <button (click)="changePassword()" class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm tw-bg-primary tw-text-secondary tw-rounded-[5px] tw-py-3">
            {{ "submit" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
